import _extends from "@babel/runtime/helpers/extends";
import { forwardRef, useCallback } from "react";
import { useBanner, bannerFooterInlineStyle, bannerFooterInlineStyleContainer, FooterLink, useCommonFooterLinks } from "../../.."; // eslint-disable-next-line react/display-name

const BannerFooter = /*#__PURE__*/forwardRef((_, ref) => {
  const banner = useBanner();
  const {
    isTcf,
    layout: {
      type
    },
    individualPrivacyOpen,
    updateIndividualPrivacyOpen,
    onClose,
    i18n: {
      tcf
    },
    isConsentRecord
  } = banner;
  const handleTcfVendorList = process.env.IS_TCF === "1" && isTcf ? useCallback(e => {
    updateIndividualPrivacyOpen(true);
    e.preventDefault();
  }, [updateIndividualPrivacyOpen]) : undefined;
  const handleClose = useCallback(e => {
    onClose();
    e.preventDefault();
  }, [onClose]);
  const {
    rows: links,
    render: renderLinks
  } = useCommonFooterLinks({
    onClose: isConsentRecord ? handleClose : undefined,
    putPoweredByLinkInRow: type === "banner" ? 0 : 1,
    row1: [process.env.IS_TCF === "1" && isTcf && !individualPrivacyOpen && h(FooterLink, {
      href: "#",
      onClick: handleTcfVendorList,
      key: "vendorList"
    }, tcf.vendorList)]
  });
  return h("div", _extends({
    ref: ref
  }, bannerFooterInlineStyleContainer(banner)), h("div", bannerFooterInlineStyle(banner), renderLinks(links)));
});
export { BannerFooter };